import {Service} from './request';
import config from "../core/config/config";
import type from '../common/js/typeUtil';
import _, {reject} from 'underscore';

export default class FileUpload {

    Unit = 'KB';//单位
    FileChunkSize = 100;//分块大小
    FileLimit = 100 * 1024; //上传文件大小限制
    SmallFileLimit = 2 * 1024;//小文件大小限制

    errorEvent = [];//错误事件
    processEvent = []; // 正在上传事件
    successEvent = []; // 上传成功事件

    constructor(fileChunkSize, fileLimit) {
        if (fileChunkSize) {
            this.FileChunkSize = fileChunkSize;
        }
        if (fileLimit) {
            this.FileLimit = fileLimit;
        }
        this.errorEvent = [];
        this.processEvent = [];
        this.successEvent = [];
        this.file = null;
        this.body = null;
        this.state = 'none';// 状态
        this.cur = 0;//上传的当前个数
    }

    getSmallFileLimit() {
        let smallFile = this.SmallFileLimit;
        switch (this.Unit) {
            case "KB":
                smallFile *= 1024;
                break;
            case "MB":
                smallFile *= 2014 * 1024;
                break;
        }
        return smallFile;
    }

    getFileSplit() {
        let split = this.FileChunkSize;
        switch (this.Unit) {
            case "KB":
                split *= 1024;
                break;
            case "MB":
                split *= 2014 * 1024;
                break;
        }
        return split;
    }

    /**
     * 上传文件
     */
    fileUpload(file, body, isStart, errorCallback, processCallback, successCallback) {
        if (!file) {
            throw new Error("未传文件");
        }
        this.file = file;
        if (body) {
            this.body = body;
        }
        if (errorCallback && type.isFunction(errorCallback)) {
            this.onError(errorCallback);
        }
        if (processCallback && type.isFunction(processCallback)) {
            this.onProcess(processCallback);
        }
        if (successCallback && type.isFunction(successCallback)) {
            this.onSuccess(successCallback);
        }
        if (isStart) {
            this.start();
        }
    }

    /**
     * 添加错误事件
     * @param errorCallback
     */
    onError(errorCallback) {
        this.errorEvent.push(errorCallback);
    }

    /**
     * 添加进行中事件
     * @param processCallback
     */
    onProcess(processCallback) {
        this.processEvent.push(processCallback);
    }

    /**
     * 添加成功事件
     * @param successCallback
     */

    onSuccess(successCallback) {
        this.successEvent.push(successCallback);
    }

    start() {
        if (this.file) {
            let size = this.file.size;
            if (size > this.getSmallFileLimit()) {
                this.cur = 0;
                let that = this;
                return new Promise((resolve, reject) => {
                    that._bigFileAdded().then(res => {
                        if (res.code === 'success') {
                            that._bigFileProcess().then(res => {
                                if (res.code === "success") {
                                    that._bigFileSuccess().then(res => {
                                        if (res.code === 'success') {
                                            resolve();
                                        } else {
                                            reject();
                                        }
                                    }).catch(res => {
                                        reject(res);
                                    });
                                } else {
                                    reject(res);
                                }
                            }).catch(res => {
                                reject(res);
                            })
                        }
                    }).catch(res => {
                        reject(res);
                    })
                });
            } else {
                this.multipartFileInfo = undefined;
                return this._singleStart();
            }
        }
        return Promise.reject();
    }

    _singleStart() {
        this.state = 'process';
        let formData = new FormData();
        formData.append("file", this.file);
        if (this.body) {
            formData.append("body", this.body);
        }
        // 文件服务接口不能拼默认 Service.baseURL (=/api/main)，必须显式
        // 覆盖为 /api/file，否则 dev 环境会被拼成 /api/main/api/file/file/upload
        let promise = Service.post("/file/upload", formData,
            {
                baseURL: config.getImgBase(),
                onUploadProgress: this.onUploadProgress.bind(this),
                onDownloadProgress: this.onDownloadProgress.bind(this)
            });
        promise.then(res => {
            this.doSuccess(res);
            this.state = 'success';
        }).catch(res => {
            this.doError(res);
            this.state = 'error';
        });
        return promise;
    }

    stop() {

    }

    doSuccess(res) {
        _.each(this.successEvent, f => {
            f(res);
        })
    }

    doError(res) {
        _.each(this.errorEvent, f => {
            f(res);
        })
    }

    onUploadProgress(progressEvent) {
        let that = this;

        _.each(this.processEvent, f => {
            if (that.multipartFileInfo) {
                let progressEventNew = JSON.parse(JSON.stringify(progressEvent));
                progressEventNew.loaded = that.multipartFileInfo.uploadedSize;
                progressEventNew.total = that.multipartFileInfo.totalSize;
                f(progressEventNew);
            } else {
                f(progressEvent);
            }
        });
    }

    onDownloadProgress(progressEvent) {

    }

    _bigFileAdded() {
        if (!this.file) return;
        this.state = 'start';
        this.multipartFileInfo = new MultipartFileInfo();
        this.multipartFileInfo.fileName = this.file.name;
        this.multipartFileInfo.mime = this.file.type;
        this.multipartFileInfo.totalSize = this.file.size;

        let promise = Service.post("/big/file/add", this.multipartFileInfo, {baseURL: config.getImgBase()});
        promise.then(res => {
            if (res.code === 'success') {
                this.multipartFileInfo.fileId = res.data.fileId;
            }
        })
        return promise;
    }

    _doBigFileProcess(cur, count, res) {
        let that = this;
        return new Promise((resolve, reject) => {
            if (cur >= count) {
                resolve(res);
            }
            let size = that.getFileSplit();
            let start = cur * size;
            let end = (cur + 1) * size;
            if (end > that.multipartFileInfo.totalSize) end = that.multipartFileInfo.totalSize;
            that.multipartFileInfo.chunkSize = size;
            that.multipartFileInfo.contentSize = end - start;
            that.multipartFileInfo.currentChunkEnd = end;
            that.multipartFileInfo.currentChunkBegin = start;
            that.multipartFileInfo.currentId = cur + 1;
            that.multipartFileInfo.totalChunk = count;
            if (that.multipartFileInfo.uploadedSize) {
                that.multipartFileInfo.uploadedSize += that.multipartFileInfo.contentSize;
            } else {
                that.multipartFileInfo.uploadedSize = that.multipartFileInfo.contentSize;
            }

            let form = new FormData();
            form.append('file', that.file.slice(start, end));
            form.append("body", JSON.stringify(this.multipartFileInfo));

            let promise = Service.post("/big/file/process", form,
                {
                    baseURL: config.getImgBase(),
                    onUploadProgress: that.onUploadProgress.bind(this),
                    onDownloadProgress: that.onDownloadProgress.bind(this)
                });
            promise.then(res => {
                if (res.code === 'success') {
                    that.cur++;
                }
                return resolve(res);
            })
            promise.catch(res => {
                that.doError(res);
                return reject(res);
            });

        }).then(res => {
            if (that.cur < count) {
                return that._doBigFileProcess(that.cur, count, res);
            }
            return Promise.resolve(res);
        })
    }

    _bigFileProcess() {
        this.state = 'process';
        let count = Math.ceil(this.multipartFileInfo.totalSize / this.getFileSplit());
        let that = this;
        return that._doBigFileProcess(that.cur, count);
    }

    _bigFileSuccess() {
        if (!this.multipartFileInfo) return
        let promise = Service.post("/big/file/end", this.multipartFileInfo, {baseURL: config.getImgBase()});
        promise.then(res => {
            if (res.code === 'success') {
                this.state = 'success';
            }
        })
        return promise;
    }
}

class MultipartFileInfo {
    constructor(fileName, mime, total) {
        this.fileName = fileName;
        this.mime = mime;
        this.totalSize = total;
    }

}